import SectionImages from './SectionImages';

export default SectionImages;
